
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/search",
      function () {
        return require("private-next-pages/faq/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq/search"])
      });
    }
  